import React, { useEffect, useState } from "react";
import AdminShell from "@/components/AdminShell";
import { getToken } from "@/lib/auth";

export default function AdminMediaModeration() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");

  const load = () => {
    const token = getToken();
    fetch("/api/admin/media/pending", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then(setItems)
      .catch((e) => setError("Failed to load media: " + e));
  };

  useEffect(() => { load(); }, []);

  const act = async (mediaId, action) => {
    const token = getToken();
    const res = await fetch(`/api/admin/media/${mediaId}/${action}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` }
    });
    if (!res.ok) {
      setError("Failed to " + action + " media");
      return;
    }
    load();
  };

  return (
    <AdminShell>
      <div className="p-6 md:p-10 text-white">
        <div className="text-[11px] tracking-[0.28em] uppercase text-[#D4AF37] mb-2">Admin</div>
        <h1 className="font-display text-3xl mb-6">Media Moderation</h1>

        {error && <div className="text-red-400 mb-4">{error}</div>}
        {items.length === 0 && !error && (
          <div className="text-white/40">No pending media.</div>
        )}

        <div className="grid gap-6 md:grid-cols-3">
          {items.map((item) => {
            const mediaId = item.media_id || item.id || item.user_id;

            return (
              <div key={mediaId} className="glass rounded-2xl border border-white/10 p-4">
                <div className="text-xs text-white/40 mb-2 uppercase">
                  {item.type || "media"}
                </div>

                {item.type === "video" ? (
                  <video src={item.url} controls className="w-full rounded-xl mb-3 bg-black" />
                ) : (
                  <img src={item.url} alt="Pending media" className="w-full rounded-xl mb-3 object-cover" />
                )}

                <div className="text-xs text-white/50 mb-1">
                  User: {item.user_id || "—"}
                </div>

                <div className="text-xs text-white/30 mb-4">
                  Created: {item.created_at ? String(item.created_at).slice(0, 19) : "—"}
                </div>

                <div className="flex gap-2">
                  <button
                    onClick={() => act(mediaId, "approve")}
                    className="flex-1 rounded-xl bg-emerald-500/15 text-emerald-300 py-2 text-sm"
                  >
                    Approve
                  </button>

                  <button
                    onClick={() => act(mediaId, "reject")}
                    className="flex-1 rounded-xl bg-red-500/15 text-red-300 py-2 text-sm"
                  >
                    Reject
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </AdminShell>
  );
}
